import isNil from 'lodash/isNil'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'

export const coerceValueFromType = (
  prevCustomFieldValue: CustomFieldValue,
  customField: CustomField | ResourceField
) => {
  const value = prevCustomFieldValue.attributes.value

  if (isNil(value)) {
    return null
  }

  switch (customField.attributes.field_type) {
    case FieldTypes.cents:
    case FieldTypes.money:
      return +value

    default:
      return value
  }
}
